module.exports = __webpack_public_path__ + "img/logo_delivery_pickup.69f7b9d.svg";